import axios from "axios";
import { Star } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { Textarea } from "src/components/ui/textarea";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { useTheme } from "next-themes";
import { SelectMembers } from "./SelectMembers";

export const ShowAddSheet = ({ handleFetchTeams, users }) => {
  const [showAddSheet, setShowAddSheet] = useState(false);
  const [addRecord, setAddRecord] = useState({
    name: "",
    description: "",
    review: "0",
    users: [],
  });
  const [loadinEdit, setLoadinEdit] = useState(false);

  const handleReviewChange = (value) => {
    setAddRecord((prev) => ({ ...prev, review: value.toString() }));
  };

  const [errors, setErrors] = useState({});
  const handleAdd = async (e) => {
    e.preventDefault();
    setLoadinEdit(true);
    setErrors({});

    try {
      await axios.post(`${BaseUrlApi}/teams`, addRecord);
      toast("تمت الإضافة", {
        description: "تمت إضافة المجموعة الجديدة بنجاح 🎉",
      });

      await handleFetchTeams();
      setShowAddSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoadinEdit(false);
    }
  };

  return (
    <Sheet open={showAddSheet} onOpenChange={setShowAddSheet}>
      <SheetTrigger asChild>
        <Button>إضافة مجموعة</Button>
      </SheetTrigger>
      <SheetContent side="left" dir="rtl">
        <SheetHeader className="text-start">
          <SheetTitle>إضافة مجموعة جديد</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          <div className="space-y-2">
            <label className="block font-medium">العنوان</label>
            <Input
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل العنوان"
              value={addRecord.name || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, name: e.target.value })
              }
            />
            {errors?.name && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.name[0]}
              </p>
            )}
          </div>
          <div className="space-y-2 ">
            <label className="block font-medium">الوصف</label>
            <Textarea
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الوصف"
              value={addRecord.description || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, description: e.target.value })
              }
            />
            {errors?.description && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.description[0]}
              </p>
            )}
          </div>

          <SelectMembers
            users={users}
            record={addRecord}
            setRecord={setAddRecord}
            errors={errors}
          />

          {/* Rating */}
          <div className="space-y-2 ">
            <label htmlFor="review" className="block font-medium">
              التقييم
            </label>
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  onClick={() => handleReviewChange(star.toString())}
                  key={star}
                  className={`w-5 h-5 cursor-pointer ${
                    addRecord.review >= star
                      ? "text-yellow-400 fill-yellow-400"
                      : "text-gray-300"
                  }`}
                />
              ))}
            </div>
            {errors?.review && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.review[0]}
              </p>
            )}
          </div>

          <div className=" text-end">
            <Button onClick={handleAdd} disabled={loadinEdit}>
              {loadinEdit ? "جاري الإضافة..." : "إضافة"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
